/**
 * Reid & Taylor - Native Voice Search Integration
 * Uses Web Speech API to enable hands-free voice search on storefront search forms.
 */
document.addEventListener('DOMContentLoaded', function () {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

  if (!SpeechRecognition) {
    console.log('[Voice Search] Web Speech API is not supported in this browser.');
    return;
  }

  const searchForms = document.querySelectorAll('form[action*="/search"], .predictive-search__form');

  searchForms.forEach(function (form) {
    const input = form.querySelector('input[name="q"]');
    if (!input || form.querySelector('.voice-search-btn')) return;

    // Create Microphone Button
    const micBtn = document.createElement('button');
    micBtn.type = 'button';
    micBtn.className = 'voice-search-btn';
    micBtn.setAttribute('aria-label', 'Search by voice');
    micBtn.innerHTML = `
      <svg class="voice-search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"></path>
        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
        <line x1="12" y1="19" x2="12" y2="22"></line>
      </svg>
    `;

    // Add inline styling / wrapper
    form.style.position = 'relative';

    input.parentNode.insertBefore(micBtn, input.nextSibling);

    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.lang = 'en-IN';

    let isListening = false;

    micBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (isListening) {
        recognition.stop();
      } else {
        recognition.start();
      }
    });

    recognition.onstart = function () {
      isListening = true;
      micBtn.style.color = '#e53e3e';
      micBtn.style.opacity = '1';
      micBtn.style.transform = 'scale(1.15)';
      input.placeholder = 'Listening... Speak now';
    };

    recognition.onresult = function (event) {
      let transcript = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        transcript += event.results[i][0].transcript;
      }
      input.value = transcript;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    recognition.onerror = function (event) {
      console.warn('[Voice Search Error]:', event.error);
      resetState();
    };

    recognition.onend = function () {
      resetState();
      if (input.value.trim().length > 0) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    };

    function resetState() {
      isListening = false;
      micBtn.style.color = 'currentColor';
      micBtn.style.opacity = '0.7';
      micBtn.style.transform = 'scale(1)';
      input.placeholder = input.getAttribute('data-original-placeholder') || 'Search...';
    }

    if (!input.getAttribute('data-original-placeholder')) {
      input.setAttribute('data-original-placeholder', input.placeholder || 'Search...');
    }
  });
});
